module.exports = __webpack_public_path__ + "files/pdf/TRADEAPPONE_POLITICA_DE_COOKIE_E_PRIVACIDADE.4c9cfbf2c506c435f41e8e53e3f41a.pdf";